// @ts-nocheck

import React, { useCallback, useEffect, useRef } from 'react';
import styled from 'styled-components';

import Client from '../../client';
import useRouter from '../../hooks/useRouter';
import { getLang } from '../../i18n/l10n';
import { ApplicationPlatforms } from '../../types/application';
import type { Licence } from '../../types/common';
import { RoutePatterns } from '../../types/routes';
import { type UserAccountPage, UserAccountMessages } from '../../types/user-account';

const FRAME_TARGET_NAME = 'my-account-frame';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

const UserAccountApiForm = styled.form`
  display: none;
`;

const Frame = styled.iframe`
  height: 100%;
  width: 100%;
  border: none;
`;

type UserAccountProps = {
  licence: Licence;
  jwt: string;
  userAccountFormUrl: string;
  onClose: (...params: unknown) => unknown;
  doLogout: (...params: unknown) => unknown;
  subpath: UserAccountPage;
};

const UserAccount = ({ licence, jwt, userAccountFormUrl, onClose, doLogout, subpath }: UserAccountProps) => {
  const { history } = useRouter();
  const formRef = useRef();
  const iframeRef = useRef();

  const renderInput = useCallback((name, value) => <input type="hidden" name={name} value={value ?? ''} />, []);

  useEffect(() => {
    formRef.current?.submit();
  }, []);

  const onMessage = useCallback(
    (message: unknown) => {
      const { data, origin } = message;

      if (!origin || userAccountFormUrl.indexOf(origin) !== 0) {
        // Incorrect origin
        return;
      }

      if (data) {
        const { type, target } = data;

        switch (type) {
          case UserAccountMessages.CLOSE:
            onClose();
            break;
          case UserAccountMessages.LOGOUT:
            doLogout();
            onClose();
            break;
          case UserAccountMessages.REDIRECT:
            if (target === 'graphics-preferences') {
              history.push(RoutePatterns.GRAPHICS_PREFERENCES);
            }
            break;
          default:
        }
      }
    },
    [userAccountFormUrl, onClose, doLogout, history],
  );

  useEffect(() => {
    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, [onMessage]);

  return (
    <Wrapper>
      <UserAccountApiForm ref={formRef} action={userAccountFormUrl} target={FRAME_TARGET_NAME} method="POST">
        {renderInput('lang', getLang())}
        {renderInput('licence', licence)}
        {renderInput('jwt', jwt)}
        {renderInput('application', Client.application)}
        {renderInput('platform', ApplicationPlatforms.WEB)}
        {renderInput('store', Client.store)}
        {renderInput('store_id', Client.storeId)}
        {renderInput('origin', window.location.origin)}
        {renderInput('oid', Client.tracker)}
        {Client.appVersion ? renderInput('app_version', Client.appVersion) : null}
        {renderInput('betting_version', Client.bettingVersion)}
        {subpath ? renderInput('path', subpath) : null}
      </UserAccountApiForm>
      <Frame ref={iframeRef} name={FRAME_TARGET_NAME} allow="camera *" />
    </Wrapper>
  );
};
export default UserAccount;
